import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import {
  ClinicalReportPromptVersionDto, ClinicalReportPromptVersionRequestDto,
} from '../../dtos/clinical-report-prompt-version.dto';

@Injectable()
export class ClinicalReportPromptVersionsRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public getAll(): Observable<ClinicalReportPromptVersionDto[]> {
    return this.http.get<ClinicalReportPromptVersionDto[]>(
      `${this.apiUrl}${API_ENDPOINTS.clinicalReportPromptVersions.list}`,
    );
  }

  public create(request: ClinicalReportPromptVersionRequestDto): Observable<ClinicalReportPromptVersionDto> {
    return this.http.post<ClinicalReportPromptVersionDto>(
      `${this.apiUrl}${API_ENDPOINTS.clinicalReportPromptVersions.create}`,
      request,
    );
  }

  public update(
    versionId: string,
    request: ClinicalReportPromptVersionRequestDto,
  ): Observable<ClinicalReportPromptVersionDto> {
    return this.http.put<ClinicalReportPromptVersionDto>(
      `${this.apiUrl}${API_ENDPOINTS.clinicalReportPromptVersions.byId(versionId)}`,
      request,
    );
  }

  public remove(versionId: string): Observable<void> {
    return this.http.delete<void>(
      `${this.apiUrl}${API_ENDPOINTS.clinicalReportPromptVersions.byId(versionId)}`,
    );
  }

  public setDefault(versionId: string): Observable<ClinicalReportPromptVersionDto> {
    return this.http.put<ClinicalReportPromptVersionDto>(
      `${this.apiUrl}${API_ENDPOINTS.clinicalReportPromptVersions.setDefault(versionId)}`,
      {},
    );
  }
}
